import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {PRFatturaElettronicaPassivaComponent} from './pr-fattura-elettronica-passiva';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.pr-fattura-elettronica-passiva', {
      url: '/pr-fattura-elettronica-passiva/numero-fattura=:numeroFattura',
      params: {
        numeroFattura: '',
        status: ''
      },
      ncyBreadcrumb: {
        label: 'Fatture Ricevute',
        parent: 'home.fatturazione-pr'
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Fatture Ricevute'
      },
      views: {
        homeContent: {
          template: '<pr-fattura-elettronica-passiva flex="100"></pr-fattura-elettronica-passiva>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const PRFatturaElettronicaPassivaModule: string = ng
  .module('pr-fattura-elettronica-passiva', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('prFatturaElettronicaPassiva', PRFatturaElettronicaPassivaComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/pr-fattura-elettronica-passiva/pr-fattura-elettronica-passiva.module.ts